// import components
import { styled } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers-pro';

export const StyledDatePicker = styled(DesktopDatePicker)(() => ({
  '& button:disabled': {
    border: 'none',
    backgroundImage: 'none'
  },

  '& .MuiInputAdornment-root.MuiInputAdornment-positionEnd.MuiInputAdornment-outlined':
    {
      marginLeft: 0
    }
}));
